import { axios, path } from './config';
import { WhatsappParams } from 'interfaces/whatsAppInterfaces';

export function disconnectWhatsAppBusinessAccount({ customerId, phoneNumber }: WhatsappParams) {
  const params = {
    account_id: customerId,
    phone: phoneNumber,
  };

  return axios.post(path.DISCONNECT_WAB_ACCOUNT, null, { params });
}

export function saveWhatsappConnectionResponse({
  customerId,
  wabaId,
  phoneNumberId,
  businessProfileName,
  phoneNumber,
}: WhatsappParams) {
  const params = {
    account_id: customerId,
    whats_app_business_account_id: wabaId,
    whats_app_number_id: phoneNumberId,
    whats_app_profile_name: businessProfileName,
    phone: phoneNumber,
  };

  return axios.post(path.CONNECT_WAB_ACCOUNT, null, { params });
}

export function verifyWhatsAppNumber({ customerId, phoneNumber, otp }: WhatsappParams) {
  const params = {
    account_id: customerId,
    phone: phoneNumber,
    one_time_password: otp,
  };

  return axios.post(path.VERIFY_WHATSAPP_NUMBER, null, { params });
}
